import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    pickerLoadFailed: 'Не удалось загрузить статьи. Попробуйте ещё раз.',
    nothingFound: 'Ничего не найдено',
    searchPlaceholder: 'Поиск по названию или ссылке',
    createArticle: 'Создать статью',
    emptyTitle: 'Пока нет опубликованных статей',
    emptyDescription: 'Опубликуйте статью в разделе инструкций — и она появится здесь',
    untitledCard: 'Без заголовка',
    newInstruction: 'Новая инструкция',
    author: 'Автор',
    byLink: 'По ссылке',
    deleteTitle: 'Удалить инструкцию?',
    deleteDescription: (title: string) =>
      `«${title || 'Без названия'}» будет удалена без возможности восстановления.`,
    cancel: 'Отмена',
    delete: 'Удалить',
  },
  en: {
    pickerLoadFailed: 'Couldn’t load articles. Please try again.',
    nothingFound: 'Nothing found',
    searchPlaceholder: 'Search by title or link',
    createArticle: 'Create article',
    emptyTitle: 'No published articles yet',
    emptyDescription: 'Publish an article in My articles and it will appear here',
    untitledCard: 'Untitled',
    newInstruction: 'New article',
    author: 'Author',
    byLink: 'By link',
    deleteTitle: 'Delete article?',
    deleteDescription: (title: string) => `“${title || 'Untitled'}” will be deleted permanently.`,
    cancel: 'Cancel',
    delete: 'Delete',
  },
})
